







import { Partner } from '@/modules/kartoteka/partner';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { PageModeMixin } from '@/main/mixins/pageMode';

import { isVozidloSet } from '../../utils';
import { types } from '../../store/types';
import { store } from '../../store/edit';

export default PageModeMixin.extend({
	name: 'LeasingSelect',
	components: { PartnerSelect: Partner.components.Select },
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_LEASING_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.LEASING_CHANGE}`,
			};
		},
		isDisabled(): boolean {
			return !isVozidloSet(this.ZakazkaDruh!, this.VozidloId!) || this.isViewMode;
		},
	},
});
